import React from "react";
import { Link } from "react-router-dom";
import "./project.css";

const Projects = () => {
    return (
        <div className="container">
            <div className="nav-left nav-left-alt">
                <div className="nav-left-item">
                    <Link to="/work" className="nav-left-link is-black">
                        WORK
                    </Link>
                </div>

                <div className="nav-line is-black"></div>

                <div className="nav-left-item nav-copyright">
                    <div class="copyright">©/2022</div>
                </div>
            </div>

            <div className="content content-work">
                <div className="header-mask header-mask-large">
                    <h1 className="header header-large">Miko .</h1>
                </div>
            </div>

            <div className="wrapper wrapper-small wf-section">
                <div className="work-container">
                    <div className="description-mask">
                        <p className="description description-large">
                            Miko Gebäudereinigung Weinstadt
                        </p>
                    </div>
                    <figure className="w-richtext-figure-type-image w-richtext-align-fullwidth">
                        <div>
                            <img
                                src="https://i.ibb.co/bBFd2R8/image.png"
                                alt="miko landing page screen shot"
                            />
                        </div>
                    </figure>
                    <p>
                        I had the privilege of working on a project from start
                        to finish - Miko Gebäudereinigung Weinstadt, a fully
                        responsive website built using Next.js and Framer
                        Motion. My responsibilities included designing a
                        user-friendly interface, implementing server-side
                        rendering and caching to optimize performance, and
                        integrating various third-party services such as Google
                        My Business and domain name registration.
                        <br />
                    </p>
                    <p>
                        I also managed the GMB account and connected the domains
                        to ensure a seamless and professional website. Overall,
                        I'm proud of the final result and the opportunity to
                        have worked on this project from the very beginning.
                    </p>

                    <p>
                        I also managed the GMB account and connected the domains
                        to ensure a seamless and professional website. Overall,
                        I'm proud of the final result and the opportunity to
                        have worked on this project all by myself.
                    </p>
                </div>
            </div>

            <div className="wrapper wrapper-small wf-section">
                <div className="content-footer">
                    <blockquote class="call-to-action">
                        Check it out.
                    </blockquote>
                    <a
                        href="https://miko-gebaudereinigung.de/en"
                        target="_blank"
                        rel="noreferrer"
                        class="button w-button"
                    >
                        https://miko-gebaudereinigung.de/en
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Projects;
